module.exports = __webpack_public_path__ + "img/confirm-red.9a1fe8df.svg";